import { DataBean } from "../DataBean";

export class FiscalResponsability extends DataBean {


    public async getFiscalResponsabilityCatalog(idAccount: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFiscalResponsabilityCatalog_Number", [idAccount]);
    }
}